// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"bc91035d","522":"7fca3d63","778":"2f442ec8"}[chunkId] + ".chunk.js";
};